import React from 'react';
import HeroBanner from '../components/home/HeroBanner';
import ProductShowcaseAlternating from '../components/home/ProductShowcaseAlternating';
import ScienceSection from '../components/home/ScienceSection';
import PreFooter from '../components/home/PreFooter';

const Home = ({ cartItems = [], onAddToCart, onUpdateQuantity, onBuyNow }) => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#ffffff' }}>
      <main style={{ flex: 1 }}>
        {/* 1. HERO — CLEAN LIGHT MODE PRODUCT HERO */}
        <HeroBanner onAddToCart={onAddToCart} onBuyNow={onBuyNow} />

        {/* 2. ALTERNATING 4-PRODUCT HIGH IMPACT SHOWCASE (LEFT/RIGHT ZIG-ZAG) */}
        <ProductShowcaseAlternating
          cartItems={cartItems}
          onAddToCart={onAddToCart}
          onUpdateQuantity={onUpdateQuantity}
          onBuyNow={onBuyNow}
        />

        {/* 3. CLINICAL SCIENCE & 6 KEY BENEFITS (PAGE 9 BROCHURE) */}
        <ScienceSection />

        {/* 4. PRE-FOOTER SECTION (EXCLUSIVE TO HOME PAGE) */}
        <PreFooter />
      </main>
    </div>
  );
};

export default Home;
